'use client';

import { c as _c } from "react/compiler-runtime";
import { Checkbox as CheckboxPrimitive } from 'radix-ui';
import type * as React from 'react';
import type { JSX } from 'react';
import { Icon } from '@/components/ui/icon';
import { Tick02Icon } from '@/components/ui/icon/glyphs';
import { cn } from '@/lib/ui/utils';
function Checkbox(t0) {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("peer size-4 shrink-0 rounded-[4px] border border-border-primary shadow-xs transition-shadow outline-none focus-visible:border-border-primary focus-visible:ring-[3px] focus-visible:ring-border-primary/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-border-primary data-[state=checked]:bg-foreground-primary data-[state=checked]:text-background-primary dark:bg-border-primary/30 dark:aria-invalid:ring-destructive/40 dark:data-[state=checked]:bg-foreground-primary", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className="grid place-content-center text-current transition-none"><Icon icon={Tick02Icon} className="size-3.5" /></CheckboxPrimitive.Indicator>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <CheckboxPrimitive.Root data-slot="checkbox" className={t1} {...props}>{t2}</CheckboxPrimitive.Root>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export { Checkbox };